<template>
  <div>
    <div class="bg-gradient"></div>
    <div class="main-page">
      <div class="container-fluid px-4">
        <div class="row">
          <!-- Cp Card -->
          <div class="col-12 p-0">
            
            <div class="card enquiry-card project-card">
                <div class="card-title text-nowrap fs-13 fw-600 mb-0 text-grey my-2 pl-2">CP Connect & Collect</div>
                <div class="fs-12 fw-500 text-dark pl-2 dropdown-toggle mb-1" style="width: fit-content;" v-b-toggle.sidebar-right>{{cp_filter.credit_date_from ? $moment(cp_filter.credit_date_from).format("DD MMM YYYY"): ''}} {{cp_filter.credit_date_from ? '-' : ''}} {{cp_filter.credit_date_upto ? $moment(cp_filter.credit_date_upto).format("DD MMM YYYY"): ''}}</div>
                <apexchart width="100%" style="max-width: 250px; margin: 0 auto;" type="pie" :options="chartOptions" :series="series"></apexchart>

                <div class="d-flex justify-content-between px-3 py-2">
                  <div class="fs-15 fw-500">
                    <div class="fs-12 text-grey bullet bullet-orange">Earned</div>
                    <div class="ml-2 ">{{points.earned}}</div>
                  </div>
                  <div class="fs-15 fw-500">
                    <div class="fs-12 text-grey bullet bullet-black">Redeemed</div>
                    <div class="ml-2 ">{{points.redeemed}}</div>
                  </div>
                  <div class="fs-15 fw-500">
                    <div class="fs-12 text-grey bullet bullet-yellow">Expired</div>
                    <div class="ml-2 ">{{points.expired}}</div>
                  </div>
                </div>
            </div>
            <div class="search-holder mt-30 search-holder-list">
              <div class="input-group">
                <input type="text" placeholder="Search CP" @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control" @keyup.enter="FilterData" />
                <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14" class="close r-70">
                  <g>
                    <g>
                      <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                            L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                            c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                            l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                            L284.286,256.002z" />
                    </g>
                  </g>
                </svg>
                <div class="input-group-append align-fix" id="button-addon4">
                  <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background: new 0 0 451 451" xml:space="preserve">
                      <g>
                        <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                        s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                        C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                        s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="card enquiry-card project-card">
              <b-list-group class="list-group-flush">
                <b-list-group-item class="project-heading">
                  <div class="row">
                    <div class="col-5 pr-1">
                      <span class="name">CP Name</span>
                    </div>
                    <div class="col-2 pl-1 pr-0 text-center">
                      <span class="name">Earned</span>
                    </div>
                    <div class="col-3 pl-1 pr-0 text-center">
                      <span class="name">Redeemed</span>
                    </div>
                    <div class="col-2 pl-1 pr-0 text-center">
                      <span class="name">Expired</span>
                    </div>
                  </div>
                </b-list-group-item>
                <b-list-group-item v-for="item in cp_engagements" :key="item.id">
                  <div class="row">
                    <div class="col-5 pr-1">
                      <router-link class="name ellipses underline m-0" :to="{ name: 'CpEngagementDetails', params: {  id: item.id }, query: {credit_date_from: cp_filter.credit_date_from, credit_date_upto: cp_filter.credit_date_upto, status: 'earned'}}">{{item.name}} </router-link>
                    </div>
                    <div class="col-2 pl-1 pr-0 text-center">
                      <router-link class="project-count" :to="{ name: 'CpEngagementDetails', params: {  id: item.id }, query: {credit_date_from: cp_filter.credit_date_from, credit_date_upto: cp_filter.credit_date_upto, status: 'earned'}}">{{item.broker_earned_count}}</router-link>
                    </div>
                    <div class="col-3 pl-1 pr-0 text-center">
                      <router-link class="project-count" :to="{ name: 'CpEngagementDetails', params: {  id: item.id }, query: {credit_date_from: cp_filter.credit_date_from, credit_date_upto: cp_filter.credit_date_upto, status: 'redeemed'}}">{{item.broker_redeemed_count}}</router-link>
                    </div>
                    <div class="col-2 pl-1 pr-0 text-center">
                      <router-link class="project-count" :to="{ name: 'CpEngagementDetails', params: {  id: item.id }, query: {credit_date_from: cp_filter.credit_date_from, credit_date_upto: cp_filter.credit_date_upto, status: 'expired'}}">{{item.broker_expired_count}}</router-link>
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <span class="result-Text text-grey text-center fs-12 fw-400">Showing {{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
            </div>
          </div>
        </div>
        <paginate v-if="totalPages > 1"  v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :prev-text="'Prev'" :next-text="'Next'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'">
        </paginate>
          <!-- Right Menu Sidebar -->
          <b-sidebar id="sidebar-right" ref="sidebar-right" title="Date Filter" bg-variant="white" backdrop right shadow>
            <template v-slot="{ hide }">
            <div class="card form-card sidebar-form-card">
              <b-form @submit.prevent="AdvancedFilter" @reset="resetAdvancedFilter">
                <b-form-group label="Show Collection">
                  <div class="row">
                    <div class="col-6 pr-1">
                      <datetime type="date" v-model="cp_filter.credit_date_from" placeholder="From Date"></datetime>
                    </div>
                    <div class="col-6 pl-1">
                      <datetime type="date" v-model="cp_filter.credit_date_upto" placeholder="To Date"></datetime>
                    </div>
                  </div>
                </b-form-group>
                 <b-form-group class="btn-fixed">
                <b-button variant="primary" type="submit" block @click="hide">Apply</b-button>
                 <b-button variant="primary-outline" block type="reset">Reset</b-button>
              </b-form-group>
              </b-form>
            </div>
            </template>
          </b-sidebar>
      </div>
    </div>
  </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
import { paramsFromQuery } from "@/assets/scripts/utility.js";
import qs from "qs";
export default {
  components: {
    datetime: Datetime,
  },
  name: "Engagement",
  data() {
    return {
      filter_date: '',
      cp_engagements: [],
      total: 0,
      perPage: 0,
      Filter: this.$route.query.search_query,
      cp_filter: {
        credit_date_from: null,
        credit_date_upto: null
      },
      advSearchParams: [],
      points: {},
      series: [44, 55, 100],
      chartOptions: {
        dataLabels:{
          enabled: false,
        },
        labels: ['Earned', 'Redeemed', 'Expired'],
        responsive: [
        {
          breakpoint: 1000,
          options: {
            legend: {
              position: "bottom"
            }
          }
        }
      ],
        colors:['#FF9F40', '#0D2535', '#F4BE37'],
      }
    }
  },
  created() {
    this.cp_filter['credit_date_from'] = this.$moment().startOf('month').add(1, 'd').format('YYYY-MM-DD')
    this.cp_filter['credit_date_upto'] = this.$moment().endOf('month').add(1, 'd').format('YYYY-MM-DD')
    this.AdvancedFilter()
    this.fetchEngagementDetails();
  },
  watch: {
    $route(to, from) {
      this.AdvancedFilter()
      this.fetchEngagementDetails();
    },
  },
  computed: {
    totalPages() {
      if (this.total === 0 || this.perPage === 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.perPage);
      }
    },
    pageNo: {
      get() {
        let pageNo = this.$route.query.pageNo || 1;
        return parseInt(pageNo);
      },
      set() {
        true;
      },
    },
    pageStart() {
      if (this.total === 0) {
        return 0;
      }
      return Math.max(0, (this.pageNo - 1) * this.perPage + 1);
    },
    pageEnd() {
      if (this.total === 0) {
        return 0;
      }
      return Math.min(this.total, this.pageNo * this.perPage);
    },
  },
  methods: {
    AdvancedFilter() {
      let searchParams = this.cp_filter
      let newQ
      if (this.Filter) {
        newQ = {...searchParams, is_advanced_search: true, search_query: this.Filter};
      } else {
        newQ = {...searchParams, is_advanced_search: true};
      }

      this.$router.replace({query: newQ});
    },
    resetAdvancedFilter() {
      this.cp_filter = {credit_date_from: null,credit_date_upto: null}
      let rQ = this.$route.query
      if (rQ.is_advanced_search) {
        this.$router.replace({
          query: {}
        });
      }
    },
    resetFilter() {
      let rQ = this.$route.query;
      this.Filter = "";
      if (rQ.search_query) {
        let {
          search_query,
          ...newQ
        } = rQ;
        this.$router.replace({
          query: newQ
        });
      }
    },
    FilterData() {
      if (this.Filter) {
        let newQ = {
          ...this.$route.query,
          search_query: this.Filter
        };
        this.$router.replace({
          query: newQ
        });
      }
    },
    goToPage(pageNo) {
      let newQ = {
        ...this.$route.query,
        pageNo
      };
      this.$router.replace({
        query: newQ
      });
    },
    fetchEngagementDetails() {
      let queryP = {}
      if(this.$route.query.is_advanced_search){
        let searchParams = this.$route.query
        for(let key in searchParams){
          queryP[key] = searchParams[key];
        }
        this.advSearchParams = queryP
      }
      if (this.advSearchParams.length > 0){
        paramsFromQuery(queryP, this.advSearchParams);
      }
      else{
        paramsFromQuery(queryP, this.$route.query);
      }
      this.$axios.get(`brokers/cp_engagement`, {
        params: queryP,
        paramsSerializer: (params) =>
          qs.stringify(params, {
            arrayFormat: "brackets"
          }),
      }).then((res) => {
        this.cp_engagements = res.data.cp_engagements;
        this.series = [res.data.earned, res.data.redeemed, res.data.expired]
        this.points = {earned: res.data.earned, redeemed: res.data.redeemed, expired: res.data.expired}
        this.perPage = res.data.per_page;
        this.total = res.data.count;
      });
    }
  }
}
</script>
<style scoped>
.badge-secondary {
  color: #fff;
  background-color: #F58322;
  margin-right: -10px;
}

.underline {
  text-decoration: underline;
  padding-top: 10px;
}

.float-btn {
  margin-top: 100px;
}

.btn-primary-light {
  background: rgba(245, 131, 34, 0.1);
  border-radius: 4px;
  padding: 2px 10px;
}
</style>